import React from "react";

export default function ProductFormModal({

    open,

    onClose,

    title = "Add Product",

    children,

    onSave,

    saving = false

}) {

    if (!open) {

        return null;

    }

    return (

        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.55)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
                padding: 30
            }}
        >

            <div
                style={{
                    width: "100%",
                    maxWidth: 950,
                    height: "90vh",
                    background: "#fff",
                    borderRadius: 20,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    boxShadow: "0 30px 70px rgba(0,0,0,.25)"
                }}
            >

                {/* Header */}

                <div
                    style={{
                        height: 70,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0 28px",
                        borderBottom: "1px solid #eee",
                        background: "#fafafa"
                    }}
                >

                    <h2
                        style={{
                            margin: 0,
                            fontSize: 22,
                            fontWeight: 700
                        }}
                    >
                        {title}
                    </h2>

                    <button
                        onClick={onClose}
                        style={{
                            border: "none",
                            background: "#f1f1f1",
                            width: 42,
                            height: 42,
                            borderRadius: "50%",
                            cursor: "pointer",
                            fontSize: 22,
                            fontWeight: 700
                        }}
                    >
                        �
                    </button>

                </div>

                {/* Body */}

                <div
                    style={{
                        flex: 1,
                        overflowY: "auto",
                        padding: 30,
                        background: "#f8f9fb"
                    }}
                >

                    {children}

                </div>

                {/* Footer */}

                <div
                    style={{
                        height: 80,
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: 15,
                        padding: "0 30px",
                        borderTop: "1px solid #eee",
                        background: "#fff"
                    }}
                >

                    <button
                        onClick={onClose}
                        style={{
                            padding: "12px 24px",
                            borderRadius: 10,
                            border: "1px solid #ddd",
                            background: "#fff",
                            cursor: "pointer",
                            fontWeight: 600
                        }}
                    >
                        Cancel
                    </button>

                    <button
                        onClick={onSave}
                        disabled={saving}
                        style={{
                            padding: "12px 28px",
                            border: "none",
                            borderRadius: 10,
                            background: "rgb(255,0,204)",
                            color: "#fff",
                            cursor: "pointer",
                            fontWeight: 700,
                            opacity: saving ? .7 : 1
                        }}
                    >
                        {saving ? "Saving..." : "Save Product"}
                    </button>

                </div>

            </div>

        </div>

    );

}